import { render, staticRenderFns } from "./Projetos.vue?vue&type=template&id=042991bc&"
import script from "./Projetos.vue?vue&type=script&lang=js&"
export * from "./Projetos.vue?vue&type=script&lang=js&"
import style0 from "./Projetos.vue?vue&type=style&index=0&id=042991bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports